import { Dialog, Box, IconButton, Typography, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { forwardRef } from 'react';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const MainDialogBox = forwardRef((
  {
    open,
    handleClose,
    children,
    width,
    padding,
    heading,
    isShowClose = true,
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
  headingVariant="h4"
  },
  ref
) => {
  return (
    <Dialog
      open={open}
    
      fullWidth
      maxWidth="lg"
      slots={{ transition: Transition }}
 onClose={disableBackdropClick ? undefined : handleClose}

            disableEscapeKeyDown={disableEscapeKeyDown}
      sx={{ bgcolor: "transparent", boxShadow: "none" }}
      slotProps={{
        paper: {
          sx: {
            bgcolor: "transparent",
            boxShadow: "none",
            width: { lg: width || "80%", xs: "100%" },
            maxWidth: { lg: width || "80%", xs: "100%" },
            maxHeight: "90vh",
            height: "auto",
            display: "flex",
            flexDirection: "column",
            borderRadius: "10px",
          },
        },
      }}
    >

      {
        isShowClose && (
          <Box sx={{ position: "relative", p: 2 }}>
            <IconButton
              sx={{
                position: "absolute",
                top: "20px",
                right: "5px",
                zIndex: 1000,
                bgcolor: "text.secondary",
                p: 0.1,
                borderRadius: "50%",
                boxShadow: 2,
                "&:hover": { backgroundColor: "text.secondary" },
              }}
              onClick={handleClose}
            >
              <CloseIcon sx={{ color: "#000", fontSize: "25px" }} />
            </IconButton>
          </Box>
        )
      }

      <Box
        sx={{
          flex: 1,
          px: { sm: "30px", xs: "10px" },
          py: { sm: "20px", xs: "10px" },
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          ref={ref}
          sx={{
            bgcolor: "#fff",
            flex: 1,
            p: 3,
            borderRadius: "10px",
            padding: { lg: padding || "40px 30px", xs: "15px" },
            maxHeight: "calc(100vh - 150px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none"
            }
          }}
        >
          <Typography variant={headingVariant} fontWeight={500} mb={2}>
            {heading}
          </Typography>
          {children}
        </Box>
      </Box>
    </Dialog>
  );
});

export default MainDialogBox;
